import { AllocatedMinutes } from 'components/organisms/resource-management/types';
import { getDetailedAllocationData } from 'components/organisms/resource-management/utils/common';
import { formatTimeWithoutIgnoringNonZeroMinutes } from 'components/organisms/resource-management/utils/dates';
import { TranslationKey, useTranslate } from 'hooks/use-translation';

interface Props {
  translate: ReturnType<typeof useTranslate>;
  softAllocationsEnabled?: boolean;
  name?: string;
  capacity: number;
  allocatedMinutes: AllocatedMinutes;
}

export const userSummaryTemplateForMonthAndWeekView = ({
  translate,
  softAllocationsEnabled,
  name,
  capacity,
  allocatedMinutes,
}: Props): string => {
  const {
    totalAllocatedMinutes,
    hardAllocatedMinutes,
    softAllocatedMinutes,
    availableMinutes,
  } = getDetailedAllocationData(allocatedMinutes, capacity);

  return `
  <table>
    <tr>
      <th colspan="3">
        <strong>${name}</strong>
      </th>
    </tr>
    <tr style="height: var(--spacing-05);"></tr>
    <tr>
      <td colspan="2">
        ${translate(
          'resource_management.user_summary.tooltip.total_capacity' as TranslationKey,
        )}
        &nbsp;
      </td>
      <td align="right">
        ${formatTimeWithoutIgnoringNonZeroMinutes(capacity)}
      </td>
    </tr>
    <tr>
      <td colspan="2">
        ${translate(
          'resource_management.user_summary.tooltip.allocations' as TranslationKey,
        )}
        &nbsp;
      </td>
      <td align="right">
        ${formatTimeWithoutIgnoringNonZeroMinutes(totalAllocatedMinutes)}
      </td>
    </tr>
    ${
      softAllocationsEnabled
        ? `<tr>
            <td> • </td>
            <td>
              ${translate(
                'resource_management.user_summary.tooltip.allocations.hard' as TranslationKey,
              )}
              &nbsp;
            </td>
            <td align="right">
              ${formatTimeWithoutIgnoringNonZeroMinutes(hardAllocatedMinutes)}
            </td>
          </tr>
          <tr>
            <td> • </td>
            <td>
              ${translate(
                'resource_management.user_summary.tooltip.allocations.soft' as TranslationKey,
              )}
              &nbsp;
            </td>
            <td align="right">
              ${formatTimeWithoutIgnoringNonZeroMinutes(softAllocatedMinutes)}
            </td>
          </tr>`
        : ''
    }
    <tr style="height: var(--spacing-05);"></tr>
    <tr>
      <td colspan="3">
        ---
      </td>
    </tr>
    <tr style="height: var(--spacing-05);"></tr>
    <tr>
      <td colspan="2">
        ${translate(
          'resource_management.user_summary.tooltip.remaining_hours' as TranslationKey,
        )}
        &nbsp;
      </td>
      <td align="right" style="color:${
        availableMinutes > 0 ? 'var(--green-20)' : 'var(--red-30)'
      }">
        ${formatTimeWithoutIgnoringNonZeroMinutes(availableMinutes)}
      </td>
    </tr>
  </table>
  `;
};
